export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-array/src/constant.js
// module id = r+bP
// module chunks = 0